import { Controller } from 'stimulus'
import Rails from "@rails/ujs";


export default class extends Controller {
  static targets = ["status"]
  static values = { timeout: Number }
  timeoutValue = 1000 // ms

  connect() {
    this.form = this.element
    this.timeout = null
    if (this.hasStatusTarget) this.statusTarget.textContent = ""

    // Listen for normal input on the form (works for normal inputs)
    this.form.addEventListener("input", () => this.scheduleSave())

    // Listen for Trix changes (works for rich text area)
    this.form.querySelectorAll("trix-editor").forEach(editor => {
      editor.addEventListener("trix-change", () => this.scheduleSave())
    })
  }

  scheduleSave() {
    clearTimeout(this.timeout)
    if (this.hasStatusTarget) this.statusTarget.textContent = "Saving..."
    this.timeout = setTimeout(() => this.save(), this.timeoutValue)
  }

  save() {
    fetch(this.form.action, {
      method: "PATCH",
      body: new FormData(this.form),
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    }).then(() => {
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = "Saved"
        setTimeout(() => { this.statusTarget.textContent = "" }, 1000)
      }
    })
  }
}